export default function Hero() {
  return (
    <section className="relative h-screen min-h-[1000px] w-full overflow-hidden bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20traditional%20Japanese%20style%20luxury%20vacation%20rental%20property%20with%20modern%20minimalist%20architecture%2C%20featuring%20clean%20white%20walls%2C%20natural%20wood%20accents%2C%20zen%20garden%20with%20carefully%20arranged%20stones%20and%20bamboo%2C%20soft%20natural%20daylight%20filtering%20through%20shoji%20screens%2C%20serene%20peaceful%20atmosphere%20with%20Mount%20Fuji%20visible%20in%20distant%20background%2C%20professional%20architectural%20photography%20showcasing%20Japanese%20aesthetic%20principles%20of%20simplicity%20and%20harmony%2C%20muted%20earth%20tones%20with%20subtle%20beige%20cream%20and%20soft%20grey%20color%20palette%2C%20ultra%20refined%20sophisticated%20design%20perfect%20for%20premium%20Japanese%20vacation%20rental%20marketing&width=1920&height=1080&seq=hero-japanese-vacation-rental-v6-001&orientation=landscape"
          alt="高級バケーションレンタル物件"
          className="w-full h-full object-cover object-center opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/80" />
      </div>

      <div className="relative h-full max-w-[1400px] mx-auto px-16 flex items-center">
        <div className="w-full pt-20">
          <div className="mb-8">
            <div className="inline-block px-5 py-2 border border-slate-300 bg-white/80 backdrop-blur-sm">
              <span className="text-slate-600 text-xs font-medium tracking-[0.3em]">VACATION RENTAL BROKERAGE</span>
            </div>
          </div>
          
          <h1 className="text-[72px] leading-[1.3] text-slate-900 mb-10 tracking-tight font-normal">
            信頼と実績で選ばれる<br />
            バケーションレンタル<br />
            <span className="font-semibold">不動産仲介サービス</span>
          </h1>

          <div className="w-16 h-[1px] bg-slate-400 mb-10" />
          
          <p className="text-slate-700 text-base leading-[2] mb-12 max-w-[680px] font-normal">
            私たちは、バケーションレンタル市場における不動産仲介のリーディングカンパニーとして、<br />
            15年にわたり培ってきた専門知識と豊富な実績をもとに、<br />
            お客様の大切な資産運用を全面的にサポートいたします。<br />
            物件選定から運用管理まで、一貫したサポート体制でお応えします。
          </p>

          <div className="flex items-center gap-4 mb-16">
            <button className="px-12 py-4 bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer">
              サービス内容を見る
            </button>
            <button className="px-12 py-4 bg-white hover:bg-slate-50 text-slate-900 text-sm font-medium border border-slate-300 transition-all duration-300 whitespace-nowrap cursor-pointer">
              資料請求
            </button>
          </div>

          <div className="flex items-start gap-12">
            <div className="border-l-2 border-slate-900 pl-6">
              <div className="text-slate-900 text-4xl font-light mb-2 tracking-tight">500<span className="text-2xl">+</span></div>
              <div className="text-slate-600 text-xs font-medium tracking-wider">取扱物件数</div>
            </div>
            <div className="border-l-2 border-slate-900 pl-6">
              <div className="text-slate-900 text-4xl font-light mb-2 tracking-tight">98<span className="text-2xl">%</span></div>
              <div className="text-slate-600 text-xs font-medium tracking-wider">顧客満足度</div>
            </div>
            <div className="border-l-2 border-slate-900 pl-6">
              <div className="text-slate-900 text-4xl font-light mb-2 tracking-tight">15<span className="text-2xl">年</span></div>
              <div className="text-slate-600 text-xs font-medium tracking-wider">業界実績</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div className="w-[1px] h-12 bg-slate-400" />
        <span className="text-slate-500 text-[10px] font-medium tracking-[0.3em]">SCROLL</span>
      </div>
    </section>
  );
}
